// extracted by mini-css-extract-plugin
module.exports = {"root":"PageInfo_root__3D3Jj","container":"PageInfo_container__3tuhH","text":"PageInfo_text__7QvGb"};